import React from 'react'
import SelectField from 'material-ui-legacy/SelectField'
import MenuItem from 'material-ui-legacy/MenuItem'
import Divider from 'material-ui-legacy/Divider'

import LinearLoader from '../UI/LinearLoader'
import Resource from '../../stores/resource'
const ServiceStore = Resource('services')

/*
Props:
- categoryId: filter by category if present
- serviceId: selected id of the service
- placeholder: Label to be shown when nothing is selected
               default: 'Select a service'
- onSelected: function(selectedServiceId, selectedService)
              called when an option is selected
- resetOnSelected: Resets selector once an option is selected. default: false
- noUnderline: remove underline if true
- value: the id of the selected service
*/
class ServiceSelector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      services: [],
      value: this.props.value || 0,
      loading: true
    }
  }

  componentWillMount() {
    const filters = this.props.categoryId
      ? { serviceCategoryId: Number(this.props.categoryId) }
      : {}
    ServiceStore.findAll(filters).then(result =>
      this.setState({ services: result.data, loading: false })
    )
  }

  _getService = serviceId =>
    this.state.services.find(
      service => Number(service.id) === Number(serviceId)
    )

  _change = (ev, key, value) => {
    const { onSelected, resetOnSelected } = this.props

    const selectedValue = Number(value)
    // Prevents selecting the title
    if (selectedValue === 0) return

    this.setState({ value: selectedValue }, () => {
      if (onSelected) {
        onSelected(this.state.value, this._getService(this.state.value))
      }
      if (resetOnSelected) this.setState({ value: 0 })
    })
  }

  render() {
    const noUnderlineStyle = { display: 'none' }

    const { loading, value, services } = this.state

    return (
      <SelectField
        fullWidth={this.props.fullWidth}
        style={this.props.style}
        underlineStyle={
          this.props.noUnderline ? noUnderlineStyle : this.props.underlineStyle
        }
        iconStyle={this.props.iconStyle}
        value={Number(value)}
        onChange={this._change}
      >
        <MenuItem
          value={0}
          primaryText={this.props.placeholder || 'Select a service'}
        />

        <Divider />

        {loading && <LinearLoader />}

        {services.map(service => (
          <MenuItem
            key={service.id}
            value={Number(service.id)}
            primaryText={service.attributes.name}
          />
        ))}
      </SelectField>
    )
  }
}

export default ServiceSelector



// WEBPACK FOOTER //
// ./src/components/Services/ServiceSelector.jsx